import { SyntheticEvent, useEffect } from 'react';
import { CompleteQuery } from 'modules/queryBuilder/types';
import { useSegmentationQueryContext } from '../contexts/segmentationQuery';
import { DEFAULT_PAGE } from '../constants';
import { SubmitType } from '../types';
import { useUsersTableContext } from '../contexts/usersTable';
import { useListReferencesContext } from '../contexts/listReferences';
import { useModalsContext } from '../contexts/modals';
import { FETCH_REFERENCES_TRIGGER } from '../components/segmentationResults/referencesInsights/constants';
import { useIsCatalogSaveRestricted } from './useIsCatalogSaveRestricted';

/** hook used when onSubmit is called for queryBuilder form */
export const useOnSubmitSegmentationQuery = () => {
  const { refreshQueryResults, setIsValidQuery, setSearchQuery } = useSegmentationQueryContext();
  const { setCurrentPage } = useUsersTableContext();
  const {
    fetch,
    fetchTrigger,
    hasReferencesBeenFetched,
    isLoading: isReferencesLoading,
  } = useListReferencesContext();
  const { showUpdateDynamicListQueryModal } = useModalsContext();
  const isCatalogSaveRestricted = useIsCatalogSaveRestricted();

  // The modal needs to be triggered to open after the first fetch
  useEffect(() => {
    if (
      hasReferencesBeenFetched &&
      !isReferencesLoading &&
      fetchTrigger === FETCH_REFERENCES_TRIGGER.MODAL &&
      !isCatalogSaveRestricted
    ) {
      showUpdateDynamicListQueryModal();
    }
  }, [hasReferencesBeenFetched, isReferencesLoading, isCatalogSaveRestricted]);

  return (searchQuery: CompleteQuery, event?: SyntheticEvent<HTMLFormElement, SubmitEvent>) => {
    setIsValidQuery(true);
    const submitId = event?.nativeEvent.submitter?.id;
    switch (submitId) {
      case SubmitType.refresh:
        refreshQueryResults({ searchQuery, page: DEFAULT_PAGE });
        setCurrentPage(DEFAULT_PAGE);
        break;
      case SubmitType.save:
        setSearchQuery(searchQuery);
        break;
      case SubmitType.update:
        setSearchQuery(searchQuery);
        if (hasReferencesBeenFetched) {
          showUpdateDynamicListQueryModal();
        } else {
          fetch(FETCH_REFERENCES_TRIGGER.MODAL);
        }
        break;
      default:
        return;
    }
  };
};
